import styled from 'styled-components';

export const Container = styled.div`

    .div-input {
        position: relative;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px; 
        border: 0.25px solid lightgray;
        padding: 0;
        box-sizing: border-box;
        margin-bottom: 2.5rem;

        @media(max-width: 360px) {
            height: 64px;
            margin-bottom: 1.5rem;
        }
    }

    .div-input-disabled {
        position: relative;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        padding: 0;
        box-sizing: border-box;
        background-color: #faf8f9;

        margin-bottom: 2.5rem;

        @media(max-width: 360px) {
            height: 64px;
            margin-bottom: 1.5rem;
        }
    }

    .div-input-focado {
        position: relative;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        padding: 0;
        box-sizing: border-box;

        margin-bottom: 2.5rem;

        @media(max-width: 360px) {
            height: 64px;
            margin-bottom: 1.5rem;
        }
    }

    .div-input-error {
        position: relative;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-bottom: 8px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
            margin-bottom: 1.5rem;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-disabled label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name .content-name,
    .div-input-disabled input:valid + .label-name .content-name,
    .div-input-disabled input:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled input:focus + .label-name::after,
    .div-input-disabled input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-disabled button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .header {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: left;

        .banner {
            width: 100%;
            height: 362px;

            object-fit: cover;

            @media (max-width: 360px) {
                height: 416px
            }
        }

            button {
                position: absolute;
                right: 0;
                top: 0;

                width: 2.5rem;
                height: 2.5rem;
                border-radius: 2.5rem;

                margin: 2rem;
                
                border: none;
                outline: none;
                background: var(--black);

                display: flex;
                align-items: center;
                justify-content: center;

                @media (max-width: 360px) {
                    margin: 1rem;
                }

                .icon {
                    padding: 0;
                    margin: 0;

                    font-size: 1.5rem;
                    color: var(--white);
                }
            }

        .content {
            position: absolute;
            padding-left: 2rem;

            display: flex;
            flex-direction: column;
            gap: 1.5rem;

            @media (max-width: 360px) {
                padding-left: 1rem;
            }

            img {
                width: 2rem;
                height: 2rem;
            }

            p {
                margin: 0;
            }

            h1 {
                margin: 0;
                line-height: 1.5;
                font-size: 2rem;
                color: var(--black);

                @media (max-width: 360px) {
                    font-size: 1.5rem;
                    max-width: 299px
                }
            }

            h5 {
                font-weight: 400;
                margin: 0;
                line-height: 2;
                font-size: 1rem;
                color: var(--black);
                opacity: 0.8;

                @media (max-width: 360px) {
                    max-width: 256px
                }

                span {
                    font-weight: bold;
                }
            }
        }
    }

    .destaques {
        padding: 3.5rem 2rem 3.8rem;
        display: flex;
        flex-direction: column;
        gap: 2.5rem;

        @media (max-width: 360px) {
            padding: 3.5rem 1rem 3.5rem;
            gap: 1.5rem;
        }

        h1 {
            font-size: 2rem;
            color: var(--black);

            padding: 0;
            margin: 0;

            @media (max-width: 360px) {
                font-size: 1.5rem;
            }
        }

        h5 {
            font-size: 1rem;
            color: var(--cor-neutra-300);
            font-weight: 400;

            padding: 0;
            margin: 0;

            @media (max-width: 360px) {
                line-height: 2;
                max-width: 257px;
            }

            span {
                font-weight: 600;
                color: var(--black)
            }
        }

        .produtos {
            padding-top: 1rem;
            display: flex;
            flex-direction: column;
            gap: 1.5rem;

            @media (max-width: 360px) {
                padding-top: 1.5rem;
            }

            .adicionar { 
                margin: 2.5rem 0 0 0;
                width: 200px;
                //height: 40px;
                border-radius: 40px;
                padding: 16px 24px;

                outline: none;
                border: none;

                font-size: 0.6rem;
                font-weight: 600;
                color: var(--white);

                background: var(--red-100);
                transition: 0.2s;

                @media (max-width: 360px) {
                    width: 100%
                }

                :hover {
                    background-color:var(--red-200)
                }

                :active {
                    background-color: var(--red-0)
                }
            }

            .produto-filled {
                width: 100%;
                height: 80px;

                display: flex;
                box-sizing: border-box;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                background: var(--cor-neutra-100);
                border: 2px dashed var(--cor-neutra-1000);
                border-radius: 0.5rem;

                padding: 0 2rem;

                @media (max-width: 360px) {
                    padding: 0 1.5rem;
                    height: 144px;

                    gap: 0.5rem;
                }

                img {
                    width: 1rem;
                    height: 1rem;
                }

                span {
                    color: var(--cor-neutra-200);
                    font-size: 1rem;
                    font-weight: 600;
                }

                .middle-content {
                    display: none;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: left;

                    gap: 1rem;

                    p {
                        margin: 0;
                        padding: 0;

                        font-size: 1rem;
                        font-family: Montserrat, sans-serif;
                        color: var(--cor-neutra-300)
                    }

                    span {
                        font-weight: 600 !important;
                    }

                    @media (max-width: 360px) {
                        display: flex
                    }
                }

                .left {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: row;

                    gap: 1rem;

                    @media (max-width: 360px) {
                        .name {
                            display: none;
                        }

                        /* img {
                            margin-bottom: 3rem
                        } */
                    }

                    img {
                        width: 48px;
                        height: 48px;
                        border-radius: 4px;

                        object-fit: cover;
                    }

                    span {
                        font-weight: 500;

                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3; /* number of lines to show */
                        -webkit-box-orient: vertical;

                        max-width: 202px;
                    }
                }

                .right {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: row;

                    @media (max-width: 360px) {
                        position: relative
                    }

                    span {
                        font-size: 0.75rem;
                        font-weight: 500;

                        @media (max-width: 360px) {
                            display: none
                        }

                        a {
                            font-weight: 600;
                        }
                    }

                    button {
                        background: transparent;
                        outline: none;
                        border: none;

                        margin: 0 0 0 2rem;

                        .icon {
                            color: var(--cor-neutra-300);;
                            font-size: 1rem;

                            @media (max-width: 360px) {
                                color: var(--cor-neutra-300)
                            }
                        }
                    }
                }
            }

            .produto {
                width: 100%;
                height: 80px;

                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                
                gap: 1rem;

                border: 2px dashed var(--cor-neutra-300);
                border-radius: 0.5rem;

                cursor: pointer;

                @media (max-width: 360px) {
                    height: 120px;
                    flex-direction: column;

                    gap: 0.5rem;
                }

                img {
                    width: 1rem;
                    height: 1rem;
                }

                span {
                    color: var(--cor-neutra-200);
                    font-size: 1rem;
                    font-weight: 600;

                    @media (max-width: 360px) {
                        max-width: 155px;
                        text-align: center;
                    }
                }
            }
        }
    }

    .configurar {
        padding: 3.5rem 2rem 4rem;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        @media (max-width: 360px) {
            padding: 3.5rem 1rem 3.5rem;
        }

        img {
            width: 2rem;
            height: 2rem;
        }

        h1 {
            margin: 0;
            padding: 0;

            line-height: 1.5;

            @media (max-width: 360px) {
                font-size: 1.5rem;
                line-height: 1.67;
            }

            p {
                padding: 0;
                margin: 0;
            }
        }

        .inputs {
            padding-top: 2rem;

            @media (max-width: 360px) {
                padding-top: 1rem;
            }
        }

        .save {
            width: 120px;
            height: 40px;
            border-radius: 20px;

            outline: none;
            border: none;

            font-size: 0.6rem;
            font-weight: 600;
            color: var(--white);

            background: var(--red-100);
            transition: 0.2s;

            @media(max-width: 360px) {
                width: 100%;
            }

            :hover {
                background-color:var(--red-200)
            }

            :active {
                background-color: var(--red-0)
            }
        }
    }
`